/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const AR_SUMMARY_TABLE = 'AR_SUMMARY_TABLE';
export const AR_SUMMERY_FIELD = 'AR_SUMMERY_FIELD';
export const AR_SUMMERY_MFG_FIELD_CLEAR_REDUX =
  'AR_SUMMERY_MFG_FIELD_CLEAR_REDUX';
